import React from 'react';

import {GetRequestResponsePayload} from '../../../../../../shared/models/api';
import {NamedStyles, useStyles} from '../../../../../../shared/hooks/styles';
import {Links} from './links';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {Text} from '../../../../../../shared/components/text';
import {Html} from '../../../../../../shared/components/html';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {useIsDesktop} from '../../../../../../shared/hooks/useIsDesktop';

export const ResponseBlock = ({
  request,
  styles,
}: {
  request: GetRequestResponsePayload | null;
  styles: NamedStyles<any>;
}) => {
  const isDesktop = useIsDesktop();

  const innerStyles = useStyles(({theme, mediaOnly}) => ({
    html: {
      ...mediaOnly(DeviceSize.desktop, {marginTop: 20}, {marginTop: 14}),
      width: '100%',
    },
    htmlBaseFont: mediaOnly(DeviceSize.desktop, theme.fonts.h5Light),
    title: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginTop: 50,
        },
        {
          marginTop: 25,
        },
      ),
    },
  }));

  return request?.response ? (
    <>
      <Text type={isDesktop ? 'h3' : 'action'} style={innerStyles.title} testID='topic-response--title'>
        Ответ службы поддержки
      </Text>
      <CustomScrollView>
        <Html
          baseFontStyle={innerStyles.htmlBaseFont}
          content={request?.response}
          style={innerStyles.html}
          testID='topic-response--body'
        />
      </CustomScrollView>
      <Links type='response' request={request} styles={styles} />
    </>
  ) : (
    <Text style={styles.noResponseText} testID='topic-no-response--text'>
      Ваше обращение получено. Ответ будет направлен в ближайшее время.
    </Text>
  );
};
